var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDinersClub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 40,
    viewBox: "0 0 60 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5396 32.9828C39.5768 33.0168 46 27.1909 46 20.1038C46 12.3544 39.5768 6.99711 32.5396 7H26.4831C19.362 6.99711 13.5 12.3558 13.5 20.1038C13.5 27.1924 19.362 33.0168 26.4831 32.9828H32.5396Z",
    fill: "#0079BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.512 8.07389C20.0042 8.07606 14.7316 13.3986 14.7294 19.9679C14.7316 26.5364 20.0042 31.859 26.512 31.8611C33.0206 31.859 38.2954 26.5364 38.2961 19.9679C38.2954 13.3986 33.0213 8.07606 26.512 8.07389ZM19.0439 19.9679C19.0425 18.449 19.4994 16.965 20.3548 15.7099C21.2102 14.4548 22.4243 13.487 23.8385 12.9329V27.0022C22.4242 26.4484 21.2099 25.4808 20.3545 24.2257C19.499 22.9707 19.0422 21.4867 19.0439 19.9679ZM29.1849 27.005V12.9321C30.6001 13.4855 31.8153 14.4533 32.6713 15.7088C33.5274 16.9643 33.9843 18.449 33.9824 19.9686C33.984 21.4881 33.5269 22.9727 32.671 24.2282C31.815 25.4836 30.6 26.4515 29.1849 27.005Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinersClub);
export default __webpack_public_path__ + "static/media/DinersClub.6c1444016e16aca41499fda171f97713.svg";
export { ForwardRef as ReactComponent };